const CATEGORIES = ["preferences", "statistics", "marketing"];

const snapshotConsent = () => {
  const consent = window.Cookiebot?.consent;
  if (!consent) return null;

  const snapshot = {};
  CATEGORIES.forEach((category) => {
    snapshot[category] = consent[category] === true;
  });
  return snapshot;
};

let previousConsent = snapshotConsent();

const narrowed = (before, after) =>
  Boolean(before && after) && CATEGORIES.some((category) => before[category] && !after[category]);

const onConsentChanged = () => {
  const currentConsent = snapshotConsent();
  if (narrowed(previousConsent, currentConsent)) {
    window.location.reload();
    return;
  }
  previousConsent = currentConsent;
};

const runGatedScripts = () => {
  if (typeof window.Cookiebot?.runScripts === "function") window.Cookiebot.runScripts();
};

window.addEventListener("CookiebotOnConsentReady", () => {
  previousConsent = previousConsent || snapshotConsent();
});
window.addEventListener("CookiebotOnAccept", onConsentChanged);
window.addEventListener("CookiebotOnDecline", onConsentChanged);

document.addEventListener("turbo:load", runGatedScripts);
document.addEventListener("turbo:render", runGatedScripts);
document.addEventListener("turbo:frame-load", runGatedScripts);
